import { useDisclosure } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Modal, OpenModal } from "../../../components/Modal";
import Builder from "../../../components/forms";
import { withdrawApi } from "../../../api";

export const Edit = ({ withdraw = false }) => {
  const disclousure = useDisclosure();
  const [fields, setFields] = useState([]);

  const editBond = (data) => {
    console.log("data", data);
    const response = withdrawApi.editWithdrawal(withdraw.name, data);
    console.log("resp", response);
    disclousure.onClose();
    //toast.success(`Retiro editado correctamente, ${data}`, { theme: "dark" });
  };

  useEffect(() => {
    if (withdraw) {
      setFields([
        {
          name: "rate",
          label: "Editar rate",
          defaultValue: withdraw.rate,
          required: true,
        },
      ]);
    }
  }, [withdraw]);

  console.log(withdraw);

  return (
    <>
      <OpenModal text="Editar Bono" icon="" disclousure={disclousure} />

      <Modal isOpen={disclousure.isOpen} onClose={disclousure.onClose}>
        <Builder fields={fields} message="Editar bono" onClick={editBond} />
      </Modal>
    </>
  );
};
